//  Passing through other format utils for backwards compatibility
import formatToUSNumber from '../formatToUSNumber/index.js';
import formatCurrency from '../formatCurrency/index.js';
import formatCurrencyConstrained from '../formatCurrencyConstrained/index.js';
import formatCurrencyPretty from '../formatCurrencyPretty/index.js';
import formatPercent from '../formatPercent/index.js';
import formatPhoneNumber from '../formatPhoneNumber/index.js';
import stringToInteger from '../stringToInteger/index.js';

/**
 * format Number
 *
 * Will format numbers to currency (usd, eur, gbp, and jpy), percentage, and constrained currency.
 * Also will return whole numbers if prettyCurrency prop is passed.
 *
 */

export { formatToUSNumber, formatCurrency, formatCurrencyPretty, formatCurrencyConstrained, formatPercent, formatPhoneNumber, stringToInteger };
export default function formatNumber(props) {
  const renderFormat = (value, style, currency) => {
    const args = {
      value,
      style,
      currency
    };
    const params = props.formatPretty ? formatCurrencyPretty(value, style) : args;
    if (params.value === 0 || params.value) {
      switch (params.style) {
        case 'currency':
          return formatCurrency(params.value, params.currency);
        case 'percent':
          return formatPercent(params.value);
        case 'currencyConstrained':
          return formatCurrencyConstrained(params.value, params.currency);
        default:
          return formatToUSNumber(params.value);
      }
    }
    return false;
  };
  return renderFormat(props.value, props.style, props.currency);
}